import { useState, useCallback } from "react";

export function useDialogActions(initialState: boolean = false): [boolean, (() => void), (() => void)] {
  const [open, setOpen] = useState<boolean>(initialState);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return [open, handleOpen, handleClose]
}
